class Dealer {
    constructor() {
        this.id = 0,
        this.identifier = "",
        this.memberid = "",
        this.ads = []
    }
}

export { Dealer }